"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpcBusSocketMessageType = void 0;
var IpcBusSocketMessageType;
(function (IpcBusSocketMessageType) {
    IpcBusSocketMessageType["Init"] = "init";
    IpcBusSocketMessageType["Data"] = "data";
    IpcBusSocketMessageType["Close"] = "close";
    IpcBusSocketMessageType["Ping"] = "ping";
    IpcBusSocketMessageType["Pong"] = "pong";
})(IpcBusSocketMessageType || (exports.IpcBusSocketMessageType = IpcBusSocketMessageType = {}));
